var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$root.token)?_c('b-container',[_c('br'),_vm._v(" "),_c('h3',[_vm._v("Scoring Events")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('SurveyList'),_vm._v(" "),_c('br')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8dacb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ScoringEvents.vue
// module id = null
// module chunks = 